import React from 'react';
import { useAIMDContext } from '../context/AIMDContext';
import { CollaboratorBar } from '../../../../../components/program-collaboration';

/** Collaborator avatars + Invite Admin, placed in line with a step's title. */
const StepInviteAdmin: React.FC = () => {
  const { groupId, state } = useAIMDContext();
  if (!groupId) return null;
  return <CollaboratorBar grpId={groupId} programName={state.requirements.programName} />;
};

export default StepInviteAdmin;
